import React from 'react';
import { BlueTextPointer } from 'components/styled-components';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from '@blueprintjs/core';
import colors from 'utils/colors';

export const OverviewCard = props => (
 
  <Card>
    <Header>
      <Status>{props.title}</Status>{' '}
      <Icon icon={props.icon} color={props.color} iconSize={Icon.SIZE_LARGE} />
    </Header>
    <Data>{props.data || '0'}</Data>
    <NavLink
      to={{
        pathname: props.filter === 'upcoming' ? '/renewals' : '/assessments',
        state: { filter: props.filter },
        filterType: props.filterType,
        filter: props.filter,
        owned: props.owned,
        filterAltName: props.filterAltName,
        displayFilter: props.displayFilter
      }}
    >
      <BlueTextPointer style={{ textAlign: 'right' }}>
        VIEW DETAILS
      </BlueTextPointer>
    </NavLink>
  </Card>
);

const Card = styled.div`
  flex-basis: 40%;
  min-width: 200px;
  background: #fff;
  border-radius: 5px;
  padding: 1rem;
  margin: 1rem;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Status = styled.span`
  font-weight: 300;
  color: ${colors.lightGray};
  letter-spacing: 1px;
  text-transform: uppercase;
`;

const Data = styled.div`
  font-weight: 500;
  font-size: 3rem;
  color: ${colors.gray};
`;
